<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-document-checked"></i> {{$t('pages.mtOutputDayQuery.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container" v-loading="loading">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.mtStd.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.mtStd.export')}}</el-button>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels :range-separator="'~'" :start-placeholder="$t('pages.mtStd.dateStartPh')" :end-placeholder="$t('pages.mtStd.dateEndPh')" :picker-options="pickerOptions0" class="mr10" style="width: 280px"></el-date-picker>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.mtStd.mine')" class="handle-select mr10">
                    <el-option v-for="item in balanceArr" :key="item.id" :label="isDisplayCompanyName ? item.fullName : item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.mtStd.search')}}</el-button>
            </div>
        </div>

        <!-- MT1082-2008 表8 产量按日查询显示（横向标准表样） -->
        <el-table :data="rows" border class="table" id="mytable" header-cell-class-name="table-header" :height="tableHeight">
            <el-table-column type="index" :label="$t('pages.mtStd.index')" width="60" align="center"></el-table-column>
            <el-table-column prop="name" :label="$t('pages.mtStd.mine')" min-width="130"></el-table-column>
            <el-table-column prop="annualCapacity" :label="$t('pages.mtStd.annualCapacity')" width="100" align="center"></el-table-column>
            <el-table-column prop="monthCapacity" :label="$t('pages.mtStd.monthCapacity')" width="130" align="center"></el-table-column>
            <el-table-column prop="dayCapacity" :label="$t('pages.mtStd.dayCapacity')" width="130" align="center"></el-table-column>
            <el-table-column prop="hourCapacity" :label="$t('pages.mtStd.hourCapacity')" width="130" align="center"></el-table-column>
            <el-table-column prop="unit" :label="$t('pages.mtStd.unit')" width="55" align="center"></el-table-column>
            <el-table-column :label="dayOutLabel()" min-width="110" align="center">
                <template slot-scope="scope">
                    <span :class="{ red: isOver(scope.row.dayOutputCnb) }">{{ scope.row.dayOutputCnb }}</span>
                </template>
            </el-table-column>
            <el-table-column v-for="h in 24" :key="'h' + h" :label="hourLabel(h - 1)" min-width="95" align="center">
                <template slot-scope="scope">
                    <span :class="{ red: isOver(scope.row.hours[h - 1]) }">{{ scope.row.hours[h - 1] }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'mtOutputDayQuery',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            loading: false,
            tableHeight: window.innerHeight * 0.75,
            isDisplayCompanyName: false,
            balanceArr: [],
            dayRows: [],
            hourMap: {},
            rows: [],
            annualCapacity: null,
            monthlyCapacity: null,
            dayCapacity: null,
            hourCap: null, // 时生产能力 = 日生产能力/16（标准3.9）
            sd: '',
            ed: '',
            query: {
                daterange: '',
                balanceId: 0
            }
        };
    },
    created() {
        this.query.daterange = [new Date(), new Date()];
        this.getBalance();
        this.getData();
    },
    methods: {
        dayOutLabel() {
            return this.$t('pages.mtStd.dayOutput') + '\\' + this.$t('pages.mtStd.cnb');
        },
        hourLabel(h) {
            return h + this.$t('pages.mtStd.hourUnit') + this.$t('pages.mtStd.output') + '\\' + this.$t('pages.mtStd.cnb');
        },
        fmtDay(d) {
            if (!d) return '--';
            var dt = new Date(d);
            return isNaN(dt.getTime()) ? '--' : dateFormat.formatDate(dt, 'yyyy-MM-dd');
        },
        // 当天 +1 天，作为小时数据查询的右开边界
        nextDay(dstr) {
            var d = new Date(dstr + ' 00:00:00');
            d.setDate(d.getDate() + 1);
            return dateFormat.formatDate(d, 'yyyy-MM-dd');
        },
        getData() {
            if (!this.query.daterange) {
                this.$notify.warning(this.$t('pages.mtStd.dateStartPh'));
                return;
            }
            var sd = dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd');
            var ed = dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd');
            if (sd > ed) {
                this.$notify.warning(this.$t('pages.mtStd.rangeError'));
                return;
            }
            this.sd = sd;
            this.ed = ed;
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            var balanceId = this.query.balanceId;
            this.loading = true;
            this.$zybhttp
                .post('ProdInquiry/DayData', {
                    startDate: new Date(sd + ' 08:00:00'),
                    endDate: new Date(ed + ' 08:00:00'),
                    balanceId: balanceId,
                    CreateUserId: userInfo.id,
                    UserName: userInfo.realName,
                    PageIndex: 1,
                    PageSize: 2000
                })
                .then((res) => {
                    if (res.data.status != 0) throw { handled: true, message: res.message };
                    this.isDisplayCompanyName = res.data.info1 == '是';
                    this.dayRows = (res.data.data && res.data.data.list) || [];
                    return this.$zybhttp.post('ProdInquiry/HourData', {
                        startDate: new Date(sd + ' 00:00:00'),
                        endDate: new Date(this.nextDay(ed) + ' 00:00:00'),
                        balanceId: balanceId,
                        CreateUserId: userInfo.id,
                        UserName: userInfo.realName,
                        PageIndex: 1,
                        PageSize: 5000
                    });
                })
                .then((res) => {
                    if (res.data.status != 0) throw { handled: true, message: res.message };
                    var map = {};
                    ((res.data.data && res.data.data.list) || []).forEach((h) => {
                        var bid = h.balanceId != null ? h.balanceId : '--';
                        var key = bid + '|' + this.fmtDay(h.date) + '|' + h.hour;
                        var w = parseFloat(h.weight);
                        if (map[key]) {
                            // 同一小时多条记录时累加产量
                            var old = parseFloat(map[key].weight);
                            map[key].weight = isFinite(old) && isFinite(w) ? old + w : map[key].weight;
                        } else {
                            map[key] = {
                                weight: h.weight,
                                cnb: h.hourCNB
                            };
                        }
                    });
                    this.hourMap = map;
                    return this.$zybhttp.post('OverproductionQuery/MonthCCData', {
                        YearMonth: sd.substring(0, 7),
                        balanceId: balanceId,
                        CreateUserId: userInfo.id,
                        UserName: userInfo.realName
                    });
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.status == 0) {
                        this.annualCapacity = res.data.info1;
                        this.monthlyCapacity = res.data.info2;
                        this.dayCapacity = res.data.info3;
                        var dc = parseFloat(res.data.info3);
                        // 标准表8示例：时生产能力 0.625 = 10/16
                        this.hourCap = isFinite(dc) && dc > 0 ? dc / 16 : null;
                    }
                    this.buildRows();
                })
                .catch((e) => {
                    this.loading = false;
                    if (e && e.handled) this.$notify.error(e.message);
                    else this.$notify.error(this.$t('pages.mtStd.fetchError'));
                });
        },
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.isDisplayCompanyName = res.data.info1 == '是';
                        this.balanceArr = [{
                            id: 0,
                            name: this.$t('pages.mtStd.all'),
                            fullName: this.$t('pages.mtStd.all')
                        }].concat(d);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch(() => this.$notify.error(this.$t('pages.mtStd.fetchError')));
        },
        // 生成标准表8行：煤矿|年生产能力|月生产能力|日生产能力|时生产能力|单位|日产量\产能比|0~23时产量\产能比
        buildRows() {
            var nameField = this.isDisplayCompanyName ? 'fullBalanceName' : 'balanceName';
            var bids = {};
            var list = this.dayRows.map((it) => {
                if (it.balanceId != null) bids[it.balanceId] = true;
                var dayKey = this.fmtDay(it.date);
                var bid = it.balanceId != null ? it.balanceId : '--';
                var hours = [];
                for (var h = 0; h < 24; h++) {
                    var cell = this.hourMap[bid + '|' + dayKey + '|' + h];
                    hours.push(cell ? this.nz(cell.weight) + '\\' + this.hourCnb(cell) : '--');
                }
                return {
                    name: it[nameField] || it.balanceName || '--',
                    sortBid: it.balanceId != null ? it.balanceId : 999999,
                    date: dayKey,
                    dayOutputCnb: this.nz(it.weight) + '\\' + this.fmtCnb(it.dayCNB),
                    hours: hours
                };
            });
            list.sort((a, b) => (a.sortBid - b.sortBid) || (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
            // 单矿（或仅一组）时才展示汇总的生产能力；多矿模式下接口仅返回合计，逐行展示会造成歧义
            var singleMine = Object.keys(bids).length <= 1;
            this.rows = list.map((r) => {
                return {
                    name: r.name,
                    annualCapacity: singleMine ? this.nz(this.annualCapacity) : '--',
                    monthCapacity: singleMine ? this.nz(this.monthlyCapacity) : '--',
                    dayCapacity: singleMine ? this.nz(this.dayCapacity) : '--',
                    hourCapacity: singleMine ? this.trimNum(this.hourCap) : '--',
                    unit: this.$t('pages.mtStd.unitT'),
                    dayOutputCnb: r.dayOutputCnb,
                    hours: r.hours
                };
            });
        },
        // 小时产能比：优先用时生产能力（日生产能力/16）计算百分比；缺失时回退接口 hourCNB
        hourCnb(cell) {
            var w = parseFloat(cell.weight);
            if (this.hourCap && isFinite(w)) return this.fmtPct((w / this.hourCap) * 100);
            return this.fmtCnb(cell.cnb);
        },
        trimNum(v) {
            var n = parseFloat(v);
            if (!isFinite(n)) return '--';
            return String(Math.round(n * 1000) / 1000);
        },
        // CNB 归一化：数值>10 视为百分数（90→90%），<=10 视为小数比率（0.9→90%），含%字符串直接使用
        fmtCnb(v) {
            if (v === null || v === undefined || v === '') return '--';
            var s = String(v).trim();
            if (s.indexOf('%') > -1) {
                var pv = parseFloat(s.replace('%', ''));
                return isFinite(pv) ? this.oneDecimal(pv) + '%' : '--';
            }
            var n = parseFloat(s);
            if (!isFinite(n)) return '--';
            var p = n > 10 ? n : n * 100;
            return this.oneDecimal(p) + '%';
        },
        // 已是百分数值直接格式化（如 产量/时生产能力×100）
        fmtPct(p) {
            return isFinite(p) ? this.oneDecimal(p) + '%' : '--';
        },
        oneDecimal(p) {
            var r = Math.round(p * 10) / 10;
            return Number.isInteger(r) ? r.toFixed(0) : r.toFixed(1);
        },
        isOver(cell) {
            if (!cell) return false;
            var parts = String(cell).split('\\');
            if (parts.length < 2) return false;
            var p = parseFloat(parts[1]);
            if (!isFinite(p)) return false;
            var ratio = p > 10 ? p / 100 : p;
            return ratio > 1; // 产能比大于100%标红（标准5.5.5.3）
        },
        nz(v) {
            return v === null || v === undefined || v === '' ? '--' : v;
        },
        printlist() {
            var sd = this.sd || dateFormat.formatDate(new Date(), 'yyyy-MM-dd');
            var ed = this.ed || sd;
            var props = [{
                    field: 'index',
                    displayName: this.$t('pages.mtStd.index'),
                    columnSize: '4%'
                },
                {
                    field: 'name',
                    displayName: this.$t('pages.mtStd.mine'),
                    columnSize: '10%'
                },
                {
                    field: 'annualCapacity',
                    displayName: this.$t('pages.mtStd.annualCapacity'),
                    columnSize: '7%'
                },
                {
                    field: 'monthCapacity',
                    displayName: this.$t('pages.mtStd.monthCapacity'),
                    columnSize: '7%'
                },
                {
                    field: 'dayCapacity',
                    displayName: this.$t('pages.mtStd.dayCapacity'),
                    columnSize: '7%'
                },
                {
                    field: 'hourCapacity',
                    displayName: this.$t('pages.mtStd.hourCapacity'),
                    columnSize: '7%'
                },
                {
                    field: 'unit',
                    displayName: this.$t('pages.mtStd.unit'),
                    columnSize: '4%'
                },
                {
                    field: 'dayOutputCnb',
                    displayName: this.dayOutLabel(),
                    columnSize: '7%'
                }
            ];
            var data = this.rows.map((r, i) => {
                var o = {
                    index: i + 1,
                    name: r.name,
                    annualCapacity: r.annualCapacity,
                    monthCapacity: r.monthCapacity,
                    dayCapacity: r.dayCapacity,
                    hourCapacity: r.hourCapacity,
                    unit: r.unit,
                    dayOutputCnb: r.dayOutputCnb
                };
                for (var h = 0; h < 24; h++) {
                    o['h' + h] = r.hours[h];
                    props.push({
                        field: 'h' + h,
                        displayName: this.hourLabel(h),
                        columnSize: '4%'
                    });
                }
                return o;
            });
            print({
                printable: data,
                header: `<div style="display: flex;flex-direction: column;text-align: center"><h3>${this.$t('pages.mtOutputDayQuery.printTitle')}（${sd} ~ ${ed}）</h3></div>`,
                properties: props,
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:left;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.mtOutputDayQuery.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        }
    }
};
</script>

<style scoped>
.handle-select {
    width: 150px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}
</style>
